import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleResponse, AxiosWidget } from '@services/SettingAxios';
import { IRecord } from '../types/TypeRecord';
import { formatPhoneToApi, formedPhone } from '@sharedHelpers/formedPhone';
import { formatDateLk } from '@sharedHelpers/formatDate';
import { RootState } from '@redux/store';

export const fetchGetRecordsTireFitting = createAsyncThunk<IRecord[], undefined, { rejectValue: { code: number } }>(
  'services/fetchGetRecordsTireFitting',
  async (query, thunkAPI) => {
    try {
      const phone = (thunkAPI.getState() as RootState).auth?.userPhone + '';

      return await AxiosWidget.post('/api/user/services', {
        phone: formatPhoneToApi(formedPhone(phone)),
      })
        .then(handleResponse)
        .then(data => {
          return data
            .map(item => {
              const [year, month, day] = item.date.date.split('-').map(value => parseInt(value));
              return {
                ...item,
                date: {
                  ...item.date,
                  textTime: formatDateLk({ day, month, year }),
                },
              };
            })
            .filter(record => record.status === 'Новая')
            .sort((a, b) => new Date(a.date.datetime).getTime() - new Date(b.date.datetime).getTime());
        });
    } catch (error) {
      const code = error.response?.status;
      return thunkAPI.rejectWithValue({ code });
    }
  },
);
